<template>
  <div class="icon down-arrow-icon" v-html="DownArrow"></div>
</template>

<script>
import DownArrow from './down-arrow.svg'
export default {
  data () {
    return {
      DownArrow: DownArrow
    }
  }
}
</script>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/DownArrow.vue